module.exports = __webpack_public_path__ + "img/winepulse-logo.4539538c.png";